import { Table } from "antd";
import Header from "../../components/Header";

const Reporting = () => {
  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
        <div className="row ">
          <div className=" col-12">
            <div className="row">
              <div className="col-6">
                <h1 className="text-2xl font-bold">Reporting</h1>
              </div>
              <div className="col-6 "></div>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Reporting;
